import { createTheme, colors } from '@material-ui/core';
import shadows from './shadows';
import typography from './typography';

const theme = createTheme({
  palette: {
    background: {
      default: '#F4F6F8',
      paper: colors.common.white
    },
    primary: {
      contrastText: '#ffffff',
      main: '#00358E'
    },
    text: {
      primary: '#00358E',
      secondary: '#111111'
    }
  },
  shadows,
  typography
});

export default theme;
